import React, { useState } from 'react';
//@ts-ignore
import * as styles from './faq.module.css';
//@ts-ignore
import { Faq as FaqType } from '../Global/DataUtils/faqQueries';
import RichText from '../Global/RichText';
import { BuildLinkHref } from '../Global/BuildLinkHref';
import { getMultiChoice } from '../Global/DataUtils';
import CtaLink from '../Global/CtaLink';
import SvgDownArrowSm from '../Global/ShowMoreArrow/SvgDownArrowSm';
import parse from 'html-react-parser';

interface Props {
    truncateBody?: boolean;
    gridSpan?: number;
    faq: FaqType;
    expanded?: boolean;
}

const Faq: React.FC<Props> = ({ truncateBody, ...props }) => {
    const [expanded, setExpanded] = useState(props.expanded || false);
    const [truncated, setTruncated] = useState(false);

    const faqStyle = props.gridSpan
        ? { gridColumn: `span ${props.gridSpan}` }
        : undefined;

    const faqElements = props?.faq?.elements;

    const cta = {
        label: faqElements?.cta_configuration__cta_label?.value,
        location: BuildLinkHref(
            faqElements?.cta_configuration__cta_location,
            faqElements?.cta_configuration__cta_location_anchor_point
        ),
        target:
            getMultiChoice(
                faqElements?.cta_configuration__cta_window_action
            ) === 'new_window'
                ? '_blank'
                : 'self',
    };

    const renderTags = () => {
        const blogTopics = faqElements?.blog_topic.value.map(
            (topic) => topic.name
        );
        const wellnessTypes = faqElements?.wellness_type.value.map(
            (type) => type.name
        );
        const country = faqElements?.country.value.map(
            (country) => country.name
        );
        const productFamily = faqElements?.product_family.value.map(
            (family) => family.name
        );
        const productType = faqElements?.product_type.value.map(
            (type) => type.name
        );
        const department = faqElements?.department?.value.map(
            (type) => type.name
        );

        let tags = [];

        if (Array.isArray(productType)) {
            tags = [...tags, ...productType];
        }

        if (Array.isArray(blogTopics)) {
            tags = [...tags, ...blogTopics];
        }

        if (Array.isArray(wellnessTypes)) {
            tags = [...tags, ...wellnessTypes];
        }

        if (Array.isArray(country)) {
            tags = [...tags, ...country];
        }

        if (Array.isArray(department)) {
            tags = [...tags, ...department];
        }

        if (tags.length === 0) return null;

        return <div className={styles.faqTags}>{tags.join(', ')}</div>;
    };

    const toggleLines = (event: any) => {
        event.preventDefault();
        setExpanded(!expanded);
    };

    const parseHtml = (htmlAsString: string) => {
        let html = htmlAsString;
        html = html.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
        html = html.replace(/\n/g, '');
        const faq = parse(html);
        return faq;
    };

    return (
        <div className={styles.faqExploration} style={faqStyle}>
            {renderTags()}
            <div
                className={styles.faqQuestion}
                onClick={toggleLines}
                data-kontent-element-codename="question"
            >
                {faqElements?.question.value}
            </div>
            <div>
                {!truncated && !expanded ? (
                    <button
                        className={styles.faqRowControls}
                        onClick={toggleLines}
                        aria-label="Expand answer"
                    >
                        <SvgDownArrowSm strokeColor="#505251" transform={'0'} />
                    </button>
                ) : (
                    <>
                        {!truncated && expanded && (
                            <>
                                <div>
                                    <div>
                                        <div className={styles.faqAnswer}>
                                            {RichText(
                                                faqElements?.answer,
                                                undefined,
                                                undefined,
                                                undefined,
                                                'answer'
                                            )}
                                        </div>
                                        {cta.location && (
                                            <div
                                                className={
                                                    styles.faqCtaContainer
                                                }
                                            >
                                                <CtaLink
                                                    href={cta.location}
                                                    target={cta.target}
                                                >
                                                    {cta.label}
                                                </CtaLink>
                                            </div>
                                        )}
                                        <button
                                            className={`${
                                                styles.faqRowControls
                                            } ${styles.faqRowOpen} ${
                                                expanded ? styles.arrowUp : ''
                                            }`}
                                            onClick={toggleLines}
                                            aria-label="Collapse answer"
                                        >
                                            <SvgDownArrowSm
                                                strokeColor="#505251"
                                                transform={'0'}
                                            />
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default Faq;
